import Vue from 'vue';
import Vuex from 'vuex';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import route from '../../vendor/tightenco/ziggy/src/js/route';
import {Ziggy} from './ziggy';
import {shopStore} from './stores/shopStore';
import {Helper} from './common/helpers';
import {Request} from './common/request';
import {BootstrapVue, IconsPlugin, ToastPlugin} from 'bootstrap-vue';
import 'bootstrap';
import VueSplide from '@splidejs/vue-splide';
import VueI18n from 'vue-i18n';
import en from './en.json';
import vi from './vi.json';
// import VueLazyload from 'vue-lazyload';
import Swal from 'vue-sweetalert2';
import VueScrollTo from 'vue-scrollto';
//plugins
import '@fortawesome/fontawesome-free/js/all.js';

Vue.use(VueI18n);

const messages  = {
    en,
    vi,
}


Vue.use( VueSplide );
// import './plugins';

// Vue.use(VueLazyload, {
//     preLoad: 0.5,
//     error: '/shop-wise/images/load.jpg',
//     loading: '/shop-wise/images/load.jpg',
//     attempt: 1
// })
// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ToastPlugin);

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.use(Vuex);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(Swal);

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    }
});

const files = require.context('./components/shop/v3', true, /\.vue$/i); // eslint-disable-line no-undef
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));


const i18n = new VueI18n({
    locale: document.head.querySelector('meta[name="locale"]').content,
    messages: messages
});

Vue.prototype.Helper  = Helper;
Vue.prototype.Request  = Request;

window._shopacc = new Vue({
    store: shopStore,
    el: '#web',
    i18n,
});
